const getMateriales = state => state.materiales;

export default {
  getMateriales,
};



// WEBPACK FOOTER //
// ./src/store/modules/materiales/getters.js